import offPlate from '../assets/off-plate.png';
export function getItemTopLabels({ customAttributes, vpRewards }, messages, discount) {
    const labels = [];
    if (vpRewards) {
        labels.push(...vpRewards.map(({ amount, imageUrl, name }) => ({
            text: `${String(amount)} ${name}`,
            labelName: 'vpRewards',
            image: imageUrl ?? '',
            name: 'vpRewards',
        })));
    }
    const off = customAttributes?.off ?? discount;
    if (off) {
        const text = messages['label.off'];
        text &&
            labels.push({
                text: text.replace('{n}', String(off)),
                labelName: 'off',
                image: offPlate,
                name: discount ? 'discount' : 'off',
            });
    }
    return labels;
}
